export type TpETLComponenTypeTemplateTableColumn = {
  id: string;
  name: string;
  dataType: string;
  description?: string;
};

type TpETLComponentTemplateDataObjectBase = {
  id: string;
  name: string;
  description?: string;
};

type TpETLComponentTemplateTextObject = TpETLComponentTemplateDataObjectBase & {
  dataType: 'text';
};
type TpETLComponentTemplateTableObject = TpETLComponentTemplateDataObjectBase & {
  dataType: 'table';
  columns: TpETLComponenTypeTemplateTableColumn[];
};
type TpETLComponentTemplateMatrixObject = TpETLComponentTemplateDataObjectBase & {
  dataType: 'matrix';
  observationMetadataColumns: TpETLComponenTypeTemplateTableColumn[];
  featureMetadataColumns: TpETLComponenTypeTemplateTableColumn[];
  linkColumnId: string; // column that links the two tables together
};

export type TpETLComponentTemplateDataObject =
  | TpETLComponentTemplateTextObject
  | TpETLComponentTemplateTableObject
  | TpETLComponentTemplateMatrixObject;

// Inputs have no additional configuration
export type TpETLComponentTemplateInputObject = TpETLComponentTemplateDataObject;

// Outputs also define metadata transfer from inputs
export type TpETLComponentTemplateOutputObject = {
  metadataTransfer?: string[];
  transferType?: 'union' | 'intersection';
} & TpETLComponentTemplateDataObject;

export interface TpETLComponentTypeTemplateParameterType {
  configParamTypeId: string;
  defaultValue?: any;
  [propName: string]: unknown;
}

export type TpETLComponentTypeTemplateParameter = {
  id: string;
  name: string;
  description?: string;
  required?: boolean;
  paramType: TpETLComponentTypeTemplateParameterType;
};

export type TpETLComponentTypeTemplate = {
  id: string;
  name: string;
  description: string;
  category: string;
  icon: string;
  params: TpETLComponentTypeTemplateParameter[];
  inputs: TpETLComponentTemplateInputObject[];
  outputs: TpETLComponentTemplateOutputObject[];
};

export function mapResponseToETLComponentTypeTemplate(response: any): TpETLComponentTypeTemplate {
  return response; // Assuming the response is already in the correct format
}
